import { BaseApi } from './base';
import { Product, ProductFilters } from '../types';
import { supabase } from '../supabase';

export class ProductsApi extends BaseApi {
  constructor() {
    super('products');
  }

  async getProducts(filters?: ProductFilters): Promise<Product[]> {
    let query = supabase
      .from('products')
      .select('*')
      .eq('status', 'active')
      .order('created_at', { ascending: false });

    if (filters?.category) {
      query = query.eq('category', filters.category);
    }

    if (filters?.metalType) {
      query = query.eq('metal_type', filters.metalType);
    }

    if (filters?.vendor) {
      query = query.ilike('vendor_name', `%${filters.vendor}%`);
    }

    if (filters?.priceRange) {
      query = query.gte('price', filters.priceRange[0]).lte('price', filters.priceRange[1]);
    }

    const { data, error } = await query;

    if (error) {
      throw new Error(`Failed to fetch products: ${error.message}`);
    }

    return data || [];
  }

  async searchProducts(searchTerm: string): Promise<Product[]> {
    return this.search<Product>(searchTerm, ['model_name', 'description', 'vendor_name']);
  }

  async getProductsByCategory(category: string): Promise<Product[]> {
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('category', category)
      .eq('status', 'active')
      .order('model_name');

    if (error) {
      throw new Error(`Failed to fetch products by category: ${error.message}`);
    }

    return data || [];
  }
}

export const productsApi = new ProductsApi();